import { IEventBus } from "../typings/event-bus";
import { EventBus } from "./event-bus";

export class TextModules {
    private readonly textContainerHeight: number = 235;
    private readonly claimDescriptionTextContainerHeight: number = 320;
    private static _instance: TextModules;
    private eventBus: IEventBus;
    private callbackActive: boolean = false;

    private constructor() {
        const scopes: NodeListOf<HTMLElement> = document.querySelectorAll('.scope-dlp') as NodeListOf<HTMLElement>;

        if(!scopes) {
            return;
        }
        
        this.init(scopes);
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }
    
    private init(scopes: NodeListOf<HTMLElement>): void {
        this.eventBus = EventBus.instance;
        const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(scopes);
        
        this.initThrowAllScopes(scopesArray);
        this.registerEvents(scopesArray);
    }
    
    private initThrowAllScopes(scopesArray: Array<HTMLElement>): void {
        for (const scope of scopesArray)
        {
            // regular page layout
            const regularPageLayout: HTMLElement = scope.querySelector('.regular-page-layout') as HTMLElement;
            const tabletLayout: HTMLElement = scope.querySelector('.tablet-layout') as HTMLElement;
            
            if(regularPageLayout && window.getComputedStyle(regularPageLayout).display !== 'none') {
                this.initializeTextModules(scope);
                this.initializeClaimDescriptionTexts(scope);
                
            }

            if(tabletLayout && window.getComputedStyle(tabletLayout).display !== 'none') {
                this.initializeTextModules(scope);
                this.initializeClaimDescriptionTexts(scope);
                
            }
        }
    }
    
    private updateTextSlots(scopesArray: Array<HTMLElement>) {

        if (this.callbackActive) {
            return;
        }

        this.callbackActive = true;
        this.initThrowAllScopes(scopesArray);
        
        this.callbackActive = false;
    }
    
    private registerEvents(scopesArray: Array<HTMLElement>): void {
        this.eventBus.subscribe(["OrientationHasChanged", "WindowSizeHasChanged"],
            this.updateTextSlots.bind(this, scopesArray)
        );
    }

    private initializeTextModules(scope: HTMLElement): void {
        const textModules: NodeListOf<HTMLElement> = scope.querySelectorAll('.dlp-text-module') as NodeListOf<HTMLElement>;
        const textModulesArray: Array<HTMLElement> = Array.prototype.slice.call(textModules);

        // usual text slot fade area handling
        for (const textModule of textModulesArray) {
            this.setFadeAreaVisibility(textModule, '.text-slot', this.textContainerHeight);
        }
    }

    private initializeClaimDescriptionTexts(scope: HTMLElement): void {
        const claimDescriptionTexts: NodeListOf<HTMLElement> = scope.querySelectorAll('.claim-description-container') as NodeListOf<HTMLElement>;
        const claimDescriptionTextsArray: Array<HTMLElement> = Array.prototype.slice.call(claimDescriptionTexts);

        // content template claim + description fade area handling 
        for (let claimDescriptionText of claimDescriptionTextsArray) {
            this.setFadeAreaVisibility(claimDescriptionText, '.claim-description-text',
                this.claimDescriptionTextContainerHeight);
        }
    }

    private setFadeAreaVisibility(textModule: HTMLElement, selector: string,
        textContainerHeight: number): void {
        const textContent: HTMLElement = textModule.querySelector(selector) as HTMLElement;
        this.setFadeAreaVisibilityForSlot(textContent, textContainerHeight);

        const textContentWide: HTMLElement = textModule.querySelector(selector + '.wide') as HTMLElement;
        this.setFadeAreaVisibilityForSlot(textContentWide, textContainerHeight);
    }

    private setFadeAreaVisibilityForSlot(slot: HTMLElement, textContainerHeight: number): void {
        const textSlotHeight: number = slot.querySelector('.short-text-container').clientHeight;
        const classToAdd: string = textContainerHeight <= textSlotHeight ? 'visible' : 'hidden';
        
        let classList = slot.querySelector('.short-text-fade-area-container').classList; 

        /*
            * Remove one by one as our good old best friend IE is not capable of removing all together :-)
            */
        classList.remove('visible');
        classList.remove('hidden');
        classList.add(classToAdd);
    }
}

TextModules.instance;
